import React from 'react';
import { CategoryFinancialWebAttributes } from 'src/types/category/categoryTypes';
import { mapUrl } from '../../logic/main/utils';
import { LaunchStrategyEnum } from '../../types/gameTypes';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';
import { GetGameLaunchStrategy } from '../LaunchStrategiesProvider/utils';
import { UserSessionContext } from '../UserSessionProvider';
import styles from './GameLink.module.scss';
import { openInNewWindow } from './openInNewWindow';

interface GameLinkProps {
  target?: string;
  url: string;
  shouldMapUrl?: boolean;
  categoryAttributes?: CategoryFinancialWebAttributes;
  notIndexed?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  integration?: string;
  dataTestId?: string;
  children?: React.ReactNode;
  emptySpaceChar?: boolean;
}

const GameLink = ({
  target = '_blank',
  url,
  shouldMapUrl = true,
  onClick = () => {},
  integration = '',
  className = styles.anchor,
  children,
  dataTestId = 'game-link',
  notIndexed,
  emptySpaceChar = true,
  categoryAttributes,
}: GameLinkProps) => {
  const { deviceType, deviceOs } = React.useContext(DeviceContext);
  const { loggedIn } = React.useContext(UserSessionContext);
  const launchStrategy = GetGameLaunchStrategy(integration);
  const shouldLaunchInPopup =
    launchStrategy === LaunchStrategyEnum['newWindow'];

  const linkUrl = shouldMapUrl
    ? mapUrl(url, deviceType, deviceOs, categoryAttributes)
    : url;

  const openerReferer = target === '_blank' ? 'noopener noreferrer ' : '';
  const noFollow = notIndexed ? 'nofollow' : '';

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!loggedIn || !shouldLaunchInPopup) return onClick(event);

    event.preventDefault();
    openInNewWindow(linkUrl);
    onClick(event);
  };

  return (
    <a
      className={className}
      data-testid={dataTestId}
      target={target}
      rel={`${openerReferer}${noFollow}`}
      href={linkUrl}
      onClick={event => handleClick(event)}
    >
      {emptySpaceChar && <span>&nbsp;</span>}
      {children}
    </a>
  );
};

export default GameLink;
